import { Role } from '@src/main/modules/roles/domain/role.interface';
import FloatLabelInput from '@src/main/shared/ui/components/input/FloatLabelInput';
import { Checkbox, CheckboxChangeEvent } from 'primereact/checkbox';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './UserForm.module.scss';

interface UserFormProps {
  values: {
    employeeId: string;
    fullName: string;
    roles: string[];
  };
  availableRoles: Role[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handleChange: (field: keyof UserFormProps['values'], value: any) => void;
  handleRoleChange: (r: string, e: CheckboxChangeEvent) => void;
  errors?: Record<string, string>;
  isEditMode: boolean;
}

const UserForm: FC<UserFormProps> = ({
  values,
  availableRoles,
  handleChange,
  handleRoleChange,
  errors,
  isEditMode,
}) => {
  const { t } = useTranslation();

  return (
    <form>
      <div className={styles.grid}>
        <FloatLabelInput
          label={t('usersManagement.employeeId')}
          value={values.employeeId}
          onChange={(val) => handleChange('employeeId', val)}
          error={errors?.employeeId}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
          disabled={isEditMode}
        />
      </div>
      <div className={styles.grid}>
        <FloatLabelInput
          label={t('usersManagement.fullName')}
          value={values.fullName}
          onChange={(val) => handleChange('fullName', val)}
          error={errors?.fullName}
          className={`${styles.field} col-12`}
          inputClassName={styles.inputfield}
        />
      </div>

      <div className={`${styles.field} col-12 mt-4`}>
        <h4 className="mt-0">{t('usersManagement.roles')}</h4>
        <div className="grid">
          {availableRoles.map((r) => (
            <div className="field-checkbox col-12" key={r.roleId}>
              <Checkbox
                inputId={`cb-${r.roleId}`}
                value={r.role}
                onChange={(e) => handleRoleChange(r.role, e)}
                checked={values.roles.includes(r.role)}
              />
              <label htmlFor={`cb-${r.roleId}`}>{r.description}</label>
            </div>
          ))}
        </div>
      </div>
    </form>
  );
};

export default UserForm;
